type LogoutMessage = {
  type: "LOGOUT";
  timestamp: number;
};

export const logoutChannel = new BroadcastChannel("tournated-logout-channel");

export const broadcastLogout = () => {
  const message: LogoutMessage = {
    type: "LOGOUT",
    timestamp: Date.now(),
  };

  try {
    logoutChannel.postMessage(message);
  } catch (error) {
    console.error("Failed to broadcast logout event:", error);
  }
};

/**
 * Sets up a listener for logout events from other tabs
 */
export const setupLogoutListener = (onLogout: () => void) => {
  const handleMessage = (event: MessageEvent<LogoutMessage>) => {
    if (event.data.type === "LOGOUT") {
      onLogout();
    }
  };

  logoutChannel.addEventListener("message", handleMessage);

  return () => {
    logoutChannel.removeEventListener("message", handleMessage);
  };
};

export const closeLogoutChannel = () => {
  logoutChannel.close();
};
